{
  "journalAudit.action.lifecycle.export_retried": "Deletion export retried",
  "journalAudit.action.lifecycle.export_retry_denied": "Export retry refused",
  "v8e.code.IDEMPOTENCY_KEY_CONFLICT": "This creation was already sent with other values: reopen the dialog.",
  "v8e.code.LIFECYCLE_ALREADY_SCHEDULED": "A deletion of this project is already scheduled.",
  "v8e.code.LIFECYCLE_CONFIRMATION_MISMATCH": "The retyped name does not match the project name.",
  "v8e.code.LIFECYCLE_DELAY_OUT_OF_RANGE": "The delay before purge is outside the platform limits.",
  "v8e.code.LIFECYCLE_EXPORT_NOT_READY": "The export archive is not ready.",
  "v8e.code.LIFECYCLE_REASON_REQUIRED": "The reason must be 10 to 1,000 characters long.",
  "v8e.code.LIFECYCLE_REQUEST_CLOSED": "This request is closed: nothing left to cancel or retry.",
  "v8e.code.PLATFORM_ADMIN_REQUIRED": "This action is reserved to the platform administration.",
  "v8e.code.STORAGE_UNAVAILABLE": "The archive store is unavailable: try again later.",
  "v8e.code.TEMPLATE_NOT_FOUND": "This template is unknown in the organisation.",
  "v8e.code.TEMPLATE_NOT_PUBLISHED": "This template is not published.",
  "v8e.code.V8E_EXPORT_NON_EN_ECHEC": "The export has not failed: nothing to retry.",
  "v8e.code.WORKSPACE_DELETION_PENDING": "A deletion is scheduled: cancel it first.",
  "v8e.code.WORKSPACE_NOT_ARCHIVED": "This project is not archived.",
  "v8e.projets.annuler.deja_purgee": "The project is already purged: nothing to cancel.",
  "v8e.projets.annuler.export_conserve": "The export archive is kept until it expires.",
  "v8e.projets.annuler.motif": "Reason (optional, at least 10 characters)",
  "v8e.projets.annuler.motif_longueur": "The reason must be at least 10 characters long.",
  "v8e.projets.annuler.projet": "Project: {{nom}}",
  "v8e.projets.annuler.retabli": "The project is restored to its state before the request.",
  "v8e.projets.annuler.retour": "Back to the request",
  "v8e.projets.annuler.verbe": "Confirm the cancellation",
  "v8e.projets.archiver.desarchivable": "It can be unarchived at any time.",
  "v8e.projets.archiver.donnees_conservees": "Its data and log are kept.",
  "v8e.projets.archiver.lecture_seule": "The project becomes read-only.",
  "v8e.projets.archiver.motif": "Reason (optional, 500 characters at most)",
  "v8e.projets.archiver.projet": "Project: {{nom}}",
  "v8e.projets.archiver.verbe": "Archive",
  "v8e.projets.creer.creer": "Create the project",
  "v8e.projets.creer.description": "Description (optional)",
  "v8e.projets.creer.modele": "Workspace template",
  "v8e.projets.creer.modele_aucun": "The organisation offers no template yet: the project gets the default template.",
  "v8e.projets.creer.nom": "Project name",
  "v8e.projets.creer.nom_longueur": "The name must be 3 to 255 characters long.",
  "v8e.projets.creer.plus_tard": "Create and launch later",
  "v8e.projets.creer.programme": "Programme",
  "v8e.projets.creer.proposer_modele": "Offer a template in the catalogue",
  "v8e.projets.creer.propriete": "You become its owner; ownership can later be transferred to a member.",
  "v8e.projets.creer.sans_programme": "No programme",
  "v8e.projets.desarchiver.consequence_ecriture": "The project becomes editable again by its members.",
  "v8e.projets.desarchiver.consequence_journal": "Unarchiving is written to the organisation log.",
  "v8e.projets.desarchiver.fait": "Project unarchived.",
  "v8e.projets.desarchiver.titre": "Unarchive “{{nom}}”?",
  "v8e.projets.desarchiver.verbe": "Unarchive",
  "v8e.projets.dialogue.projet": "the project",
  "v8e.projets.etat.actif": "Active",
  "v8e.projets.etat.archive": "Archived",
  "v8e.projets.etat.lancement_inacheve": "Launch to finish",
  "v8e.projets.etat.suppression_programmee": "Deletion scheduled",
  "v8e.projets.fiche.adresse_invalide": "Invalid address: the request number is an integer.",
  "v8e.projets.fiche.annulee_par": "Cancelled by",
  "v8e.projets.fiche.annuler": "Cancel the deletion",
  "v8e.projets.fiche.conserve": "Kept: the proof of the purge and the audit log.",
  "v8e.projets.fiche.demandee_par": "Requested by",
  "v8e.projets.fiche.echeance": "Purge after {{date}}.",
  "v8e.projets.fiche.empreinte": "SHA-256 fingerprint: {{sha}}",
  "v8e.projets.fiche.empreinte_differente": "Download fingerprint DIFFERENT from the request’s: do not trust this file.",
  "v8e.projets.fiche.empreinte_identique": "Download fingerprint identical to the request’s.",
  "v8e.projets.fiche.etat": "State",
  "v8e.projets.fiche.etat_demande.absorbee_par_la_suppression_de_l_organisation": "Superseded by the organisation deletion",
  "v8e.projets.fiche.etat_demande.annulee_par_avec_motif": "Cancelled",
  "v8e.projets.fiche.etat_demande.export_en_echec_purge_suspendue": "Scheduled — export failed, purge suspended",
  "v8e.projets.fiche.etat_demande.export_en_preparation": "Scheduled — export in preparation",
  "v8e.projets.fiche.etat_demande.export_pret": "Scheduled — export ready",
  "v8e.projets.fiche.etat_demande.purge_en_echec_plateforme_alertee": "Purge failed — the platform is alerted",
  "v8e.projets.fiche.etat_demande.purge_engagee": "Purge started",
  "v8e.projets.fiche.etat_demande.purgee_rapport_et_recu": "Purged — report and receipt kept",
  "v8e.projets.fiche.export": "Export",
  "v8e.projets.fiche.export_etat.en_echec": "Export failed: the purge is suspended until it is ready.",
  "v8e.projets.fiche.export_etat.en_preparation": "Export in preparation.",
  "v8e.projets.fiche.export_etat.expire": "Archive expired.",
  "v8e.projets.fiche.export_etat.pret": "Export ready.",
  "v8e.projets.fiche.motif": "Reason",
  "v8e.projets.fiche.perimetre": "Will be purged: the project “{{projet}}”, {{elements}} item(s), {{documents}} document(s), {{depots}} repository(ies).",
  "v8e.projets.fiche.projet": "Project",
  "v8e.projets.fiche.purge_engagee": "Purge started: the deletion can no longer be cancelled.",
  "v8e.projets.fiche.quoi": "the deletion request",
  "v8e.projets.fiche.relance_faite": "Export retried: it is in preparation again.",
  "v8e.projets.fiche.relancer": "Retry the export",
  "v8e.projets.fiche.relances": "Export retries",
  "v8e.projets.fiche.retour": "Back to projects",
  "v8e.projets.fiche.telecharger": "Download the export",
  "v8e.projets.filtre.actif": "Active",
  "v8e.projets.filtre.archive": "Archived",
  "v8e.projets.filtre.lancement_inacheve": "Launch to finish",
  "v8e.projets.filtre.sans_programme": "No programme",
  "v8e.projets.filtre.suppression_programmee": "Deletion scheduled",
  "v8e.projets.filtre.tous": "All states",
  "v8e.projets.filtre.tous_programmes": "All programmes",
  "v8e.projets.liste.actions": "Actions on {{nom}}",
  "v8e.projets.liste.archiver": "Archive",
  "v8e.projets.liste.aucun_resultat": "No project matches the search or filters.",
  "v8e.projets.liste.creer": "Create a project",
  "v8e.projets.liste.desarchiver": "Unarchive",
  "v8e.projets.liste.filtre_etat": "Project state",
  "v8e.projets.liste.filtre_programme": "Programme",
  "v8e.projets.liste.precedente": "Previous page",
  "v8e.projets.liste.proprietaire": "Owner: {{qui}}",
  "v8e.projets.liste.quoi": "the project list",
  "v8e.projets.liste.raison.archiver.suppression_programmee": "Deletion scheduled: the project is already read-only.",
  "v8e.projets.liste.raison.desarchiver.suppression_programmee": "Deletion scheduled: cancel it first to unarchive.",
  "v8e.projets.liste.raison.etat": "Unavailable in the project’s current state, or reserved to the organisation administration.",
  "v8e.projets.liste.raison.rattacher.archive": "Archived project: unarchive it first.",
  "v8e.projets.liste.raison.rattacher.suppression_programmee": "Deletion scheduled: the project is read-only.",
  "v8e.projets.liste.raison.renommer.archive": "Archived project: unarchive it first.",
  "v8e.projets.liste.raison.renommer.suppression_programmee": "Deletion scheduled: the project is read-only.",
  "v8e.projets.liste.raison.supprimer.archive": "Archived project: unarchive it first.",
  "v8e.projets.liste.raison.supprimer.suppression_programmee": "A deletion is already scheduled.",
  "v8e.projets.liste.rattacher": "Attach to a programme",
  "v8e.projets.liste.recherche": "Search (name or description, at least 2 characters)",
  "v8e.projets.liste.renommer": "Rename",
  "v8e.projets.liste.suivante": "Next page",
  "v8e.projets.liste.supprimer": "Schedule deletion",
  "v8e.projets.liste.total": "{{n}} project(s)",
  "v8e.projets.liste.vide": "The organisation has no project yet.",
  "v8e.projets.onglet.lancements": "Launches to finish",
  "v8e.projets.onglet.projets": "Projects",
  "v8e.projets.onglet.suppressions": "Scheduled deletions",
  "v8e.projets.panneau.aucun": "Choose a project in the list to see it here.",
  "v8e.projets.panneau.details": "Details",
  "v8e.projets.panneau.etat": "State",
  "v8e.projets.panneau.lecture_seule": "Archived project: read-only.",
  "v8e.projets.panneau.membres": "Members",
  "v8e.projets.panneau.ouvrir": "Open the project",
  "v8e.projets.panneau.programme": "Programme",
  "v8e.projets.panneau.proprietaires": "Owners",
  "v8e.projets.panneau.sans_programme": "No programme",
  "v8e.projets.panneau.sollicitee": "Deletion requested by the owner ({{qui}}).",
  "v8e.projets.panneau.suppression": "Deletion scheduled: purge after {{date}}.",
  "v8e.projets.panneau.voir_demande": "See the request",
  "v8e.projets.renommer.verbe": "Rename",
  "v8e.projets.suppressions.etat.cancelled": "Cancelled",
  "v8e.projets.suppressions.etat.en_echec": "Scheduled, export failed (purge suspended)",
  "v8e.projets.suppressions.etat.en_preparation": "Scheduled, export in preparation",
  "v8e.projets.suppressions.etat.expire": "Scheduled, archive expired",
  "v8e.projets.suppressions.etat.pret": "Scheduled, export ready",
  "v8e.projets.suppressions.etat.purged": "Purged",
  "v8e.projets.suppressions.etat.sollicitee": "Requested by the owner",
  "v8e.projets.suppressions.etat.superseded": "Superseded",
  "v8e.projets.suppressions.purge_le": "purge after {{date}}",
  "v8e.projets.suppressions.quoi": "the scheduled deletions",
  "v8e.projets.suppressions.vide": "No project deletion scheduled.",
  "v8e.projets.suppressions.voir": "See the request for {{nom}}",
  "v8e.projets.supprimer.annulable": "The deletion can be cancelled until the purge starts.",
  "v8e.projets.supprimer.delai": "Delay before purge, in days ({{min}} to {{max}})",
  "v8e.projets.supprimer.delai_hors_bornes": "Delay outside the platform limits.",
  "v8e.projets.supprimer.export_d_abord": "A full export is produced first, downloadable by the administration.",
  "v8e.projets.supprimer.lecture_seule": "The project becomes read-only at once.",
  "v8e.projets.supprimer.missions": "Its running missions are stopped.",
  "v8e.projets.supprimer.motif": "Reason (10 to 1,000 characters)",
  "v8e.projets.supprimer.motif_longueur": "The reason must be 10 to 1,000 characters long.",
  "v8e.projets.supprimer.ne_correspond_pas": "The name does not match.",
  "v8e.projets.supprimer.projet": "Project: {{nom}}",
  "v8e.projets.supprimer.purge": "The purge happens after the delay, only if the export is ready.",
  "v8e.projets.supprimer.retaper": "Retype the project name: {{nom}}",
  "v8e.projets.supprimer.verbe": "Schedule the deletion"
}
